import React from 'react';
import CommonButton from '../elments/CommonButton';

const RowColumnProperties = ({ isOpen, onClose, item, index, handlePropertyChange,qType }) => {
    if (!isOpen) return null;

    const checkboxFieldStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '12px'
    };

    const checkboxStyle = {
        margin: 0,
        cursor: 'pointer'
    };

    const labelStyle = {
        margin: 0,
        cursor: 'pointer'
    };

    return (
        <div className="modal-overlay">
            <div className='modal-content'>
                <div className="modal-header">
                    <span>Row/Column Properties</span>
                    <CommonButton label="&times;" title="Close" onClick={() => onClose()} />
                </div>
                    <div style={{marginBottom: '12px'}}>
                        <label htmlFor="index">Index </label>
                        <input
                            type="text"
                            id="index"
                            value={item?.index || ''}
                            onChange={(e) => handlePropertyChange(index, 'index', e.target.value)}
                        />
                    </div>
                <div className="modal-body">
                        <div style={{marginBottom: '12px'}}>
                        <label htmlFor="text">Label</label>
                        <input
                            type="text"
                            id="text"
                            value={item?.text || ''}
                            onChange={(e) => handlePropertyChange(index, 'text', e.target.value)}
                        />
                    </div>

                
                    <div style={checkboxFieldStyle}>
                        <input
                            type="checkbox"
                            id="exclusive"
                            style={checkboxStyle}
                            checked={item?.exclusive || false}
                            onChange={(e) => handlePropertyChange(index, 'exclusive', e.target.checked)}
                        />
                        <label htmlFor="exclusive" style={labelStyle}>Exclusive</label>
                    </div>

                    <div style={checkboxFieldStyle}>
                        <input
                            type="checkbox"
                            id="screenout"
                            style={checkboxStyle}
                            checked={item?.screenout || false}
                            onChange={(e) => handlePropertyChange(index, 'screenout', e.target.checked)}
                        />
                        <label htmlFor="screenout" style={labelStyle}>Screen Out</label>
                    </div>

                    <div style={checkboxFieldStyle}>
                        <input
                            type="checkbox"
                            id="fix"
                            style={checkboxStyle}
                            checked={item?.fix || false}
                            onChange={(e) => handlePropertyChange(index, 'fix', e.target.checked)}
                        />
                        <label htmlFor="fix" style={labelStyle}>Fix</label>
                    </div>

                    <div style={checkboxFieldStyle}>
                        <input
                            type="checkbox"
                            id="other"
                            style={checkboxStyle}
                            checked={item?.other || false}
                            onChange={(e) => handlePropertyChange(index, 'other', e.target.checked)}
                        />
                        <label htmlFor="other" style={labelStyle}>Other</label>
                    </div>

                    {item?.other && <div style={{marginBottom: '12px'}}>
                        <label htmlFor="filterLogic">Other Piping</label>
                        <input
                            type="text"
                            id="otherPiping"
                            value={item?.otherPiping || ''}
                            onChange={(e) => handlePropertyChange(index, 'otherPiping', e.target.value)}
                        />
                    </div>}

                    <div style={checkboxFieldStyle}>
                        <input
                            type="checkbox"
                            id="header"
                            style={checkboxStyle}
                            checked={item?.header || false}
                            onChange={(e) => handlePropertyChange(index, 'header', e.target.checked)}
                        />
                        <label htmlFor="header" style={labelStyle}>Header</label>
                    </div>
                    <div style={{marginBottom: '12px'}}>
                        <label htmlFor="quotaCounts">Quota Counts</label>
                        <input
                            type="text"
                            id="quotaCounts"
                            value={item?.quotaCounts || ''}
                            onChange={(e) => handlePropertyChange(index, 'quotaCounts', e.target.value)}
                        />
                    </div>

                    <div style={{marginBottom: '12px'}}>
                        <label htmlFor="filterLogic">Filter Logic</label>
                        <input
                            type="text"
                            id="filterLogic"
                            value={item?.filterLogic || ''}
                            onChange={(e) => handlePropertyChange(index, 'filterLogic', e.target.value)}
                        />
                    </div>
                    <div style={{marginBottom: '12px'}}>
                        <label htmlFor="termLogic">Termination Logic</label>
                        <input
                            type="text"
                            id="termLogic"
                            value={item?.termLogic || ''}
                            onChange={(e) => handlePropertyChange(index, 'termLogic', e.target.value)}
                        />
                    </div>
                    <div style={{marginBottom: '12px'}}>
                        <label htmlFor="punchLogic"> Punch Logic</label>
                        <input
                            type="text"
                            id="punchLogic"
                            value={item?.punchLogic || ''}
                            onChange={(e) => handlePropertyChange(index, 'punchLogic', e.target.value)}
                        />
                    </div>

                    {qType=="CustomRows" && <>
                    <div style={{marginBottom: '12px'}}>
                        <label htmlFor="Pretext">Pretext</label>
                        <input
                            type="text"
                            id="Pretext"
                            value={item?.Pretext || ''}
                            onChange={(e) => handlePropertyChange(index, 'Pretext', e.target.value)}
                        />
                    </div>
                                       <div style={{marginBottom: '12px'}}>
                        <label htmlFor="Posttext">Posttext</label>
                        <input
                            type="text"
                            id="Posttext"
                            value={item?.Posttext || ''}
                            onChange={(e) => handlePropertyChange(index, 'Posttext', e.target.value)}
                        />
                    </div>
                                                           <div style={{marginBottom: '12px'}}>
                        <label htmlFor="min">Min</label>
                        <input
                            type="text"
                            id="min"
                            value={item?.min || ''}
                            onChange={(e) => handlePropertyChange(index, 'min', e.target.value)}
                        />
                    </div>
                    <div>
                                        <label htmlFor="max">Max</label>
                        <input
                            type="text"
                            id="max"
                            value={item?.max || ''}
                            onChange={(e) => handlePropertyChange(index, 'max', e.target.value)}
                        />
                    </div>
                    <div style={{marginBottom: '12px'}}>
                        <label htmlFor="type">Type</label>
                        <select
                            id="type"
                            value={item?.type || ''}
                            onChange={(e) => handlePropertyChange(index, 'type', e.target.value)}
                        >
                            <option value="">Select type</option>
                            <option value="radio">Radio</option>    
                            <option value="multi">Multi</option>
                            <option value="freeze">Freeze</option>
                            <option value="open_numeric_D">Open Numeric Decimal</option>
                            <option value="open_numeric">Open Numeric</option>
                            <option value="open_string">Open String</option>
                        </select>
                    </div></>}
                </div>
                <div className="modal-footer">
                    <CommonButton label="Close" title="Close" onClick={() => onClose()} />
                </div>
            </div>
        </div>
    );
};

export default RowColumnProperties;